import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../service/authService";
import { useAppContext } from "../functions/ContextAPI";
import { toast } from "react-toastify";

const Signout = () => {
  const navigate = useNavigate();
  const { clearState } = useAppContext();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logoutUser();
        clearState();
        toast.success("Logged out successfully");
        navigate("/login");
      } catch (error) {
        console.error("Logout error:", error);
        toast.error("Error during logout");
        navigate("/login");
      }
    };

    performLogout();
  }, [navigate, clearState]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-20 h-20 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin mx-auto mb-6"></div>
        <p className="text-gray-700 font-semibold text-lg">Signing out...</p>
      </div>
    </div>
  );
};

export default Signout;